import { PureComponent } from 'react'
import PropTypes from 'prop-types'

class ConfirmController extends PureComponent {
  static propTypes = {
    onConfirm: PropTypes.func.isRequired,
  }

  state = { opened: false }
  mounted = false

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  showConfirm = () => {
    if (this.mounted) this.setState({ opened: true })
  }
  hideConfirm = () => {
    if (this.mounted) this.setState({ opened: false })
  }
  handleConfirm = async () => {
    await this.props.onConfirm()
    this.hideConfirm()
  }

  getStateAndHelpers = () => ({
    opened: this.state.opened,
    showConfirm: this.showConfirm,
    hideConfirm: this.hideConfirm,
    handleConfirm: this.handleConfirm
  })

  render() {
    return this.props.children(this.getStateAndHelpers())
  }
}

export default ConfirmController
